import { Component, Prop, h } from '@stencil/core';
import { isHurricaneAffected } from '../../../utils/utils.hurrican-warning';

@Component({
  tag: 'offer-hurricane-warning',
  styleUrl: 'offer-hurricane-warning.css',
})
export class OfferAffectedByHurricane {
  @Prop() zipCode: string = '';
  @Prop() isEligible: boolean = false;
  @Prop() isInspectionNeeded: boolean = false;
  @Prop() isFurtherReviewNormal: boolean = false;

  render() {
    const isShowWarning = isHurricaneAffected(this.zipCode);
    const hurricaneMessageClass = {
      'md:text-left text-clrs-red font-bold': true,
      'text-xs mb-6 mdLrg:text-right': this.isEligible,
      'text-base mt-6': this.isInspectionNeeded,
      'text-base mb-8': this.isFurtherReviewNormal,
    };

    return isShowWarning && (
      <div data-testid="hurricane-message" class={hurricaneMessageClass}>
        We're truly sorry to hear that you may be in an area affected by the recent hurricane and flooding. Unfortunately, we must inform you that vehicles damaged by floods or those with salvage titles are not eligible for a Kelley Blue Book® Instant Cash Offer.
      </div>
    );
  }
}
